<template>
	<div class="agenda-table">
		<template v-for="(item, index) in tableData">
			<b-tr :key="index" class="tr">
				<b-td :class="['lb', item.checked ? '' : 'nlb']"></b-td>
				<template v-for="(subItem, ind) in item.row">
					<b-td
						:key="ind"
						:class="[
							index == 0 ? 'th' : 'td',
							ind == 0 ? 'left' : '',
						]"
                        :style="{ width: ind == 0 ? '': `${(1/(item.row.length-1)* 0.75)*100}%` }"
					>
						<span v-if="ind == 0">{{ subItem }}</span>
						<div v-else class="cell">
							{{ subItem }}
						</div>
					</b-td>
				</template>
				<b-td class="rb">
					<a
						v-if="item.checked && item.flag"
						href="https://www.bagevent.com/widget/ticket/5394424"
						><div class="regbtn">
							<span>报名</span><span class="dr">︿︿</span>
						</div></a
					>
				</b-td>
			</b-tr>
		</template>

		<!-- <b-tr class="tr">
			<b-td class="lb nlb"></b-td>
			<b-td class="th left">时间</b-td>
			<b-td class="th">
				<div class="cell">
					议程
				</div>
			</b-td>
			<b-td class="rb">
				<a href="https://www.bagevent.com/widget/ticket/5394424"
					><div class="regbtn">
						<span>报名</span><span class="dr">︿︿</span>
					</div></a
				>
			</b-td>
		</b-tr>
		<b-tr class="tr">
			<b-td class="lb"></b-td>
			<b-td class="td left">9:30-12:30</b-td>
			<b-td class="td">
				<div class="cell">
					<p>开幕仪式</p>
					<p>Session Chair</p>
					<p>
						-<span class="Apple-tab-span" style="white-space: pre">
						</span
						>王晓东，未来科学大奖科学委员会委员，北京生命科学研究所资深研究员，中国科学院外籍院士，美国科学院院士
					</p>
					<p><br /></p>
					<p>开幕致辞</p>
					<p>
						-<span class="Apple-tab-span" style="white-space: pre">
						</span
						>田刚，未来科学大奖周Program
						Committee联席主席，未来论坛理事，北京国际数学研究中心主任，中国科学院院士，美国人文与科学院外籍院士
					</p>
				</div>
			</b-td>
			<b-td class="rb">
				<a href="https://www.bagevent.com/widget/ticket/5394424"
					><div class="regbtn">
						<span>报名</span><span class="dr">︿︿</span>
					</div></a
				>
			</b-td>
		</b-tr> -->
	</div>
</template>
<script>
export default {
	props: {
		table: {
			type: Array,
		},
	},
	watch: {
		table(val) {
			//   this.formatData(val);
            // console.log('-------------table', val)
            this.formatData(val)
		},
	},
	data() {
		return {
			flag: true,
			tableData: [
				// {
				// 	flag: false,
				// 	checked: false,
				// 	row: ['事件', '议程'],
				// },
				// {
				// 	flag: true,
				// 	checked: true,
				// 	row: ['12-90', '议程议程'],
				// },
				// { 
                //     checked: true, 
                //     flag: false, 
                //     row: ['12-90', '议程议程'] 
                // },
                // { 
                //     checked: false, 
                //     flag: false, 
                //     row: ['12-90', '议程议程'] 
                // },
			],
		}
	},
	methods: {
		formatData(table) {
             this.tableData = [];
            //拿到并处理首行表头
            let arr = table[0].dataItem.map(item=>{
                return item.title
            })
            this.tableData.push({
                checked: false,
                flag: false,
                row: arr
            })
            // console.log('---拿到并处理首行表头-----', this.tableData)
            //处理一下每一行
            let flagArr = table.map(item=>{
                return item.switch
                }
            )
            let flagIndex = flagArr.indexOf(true)  //查找首个并记录标记
            let rowArr = table.map((item, index) => {
                return{
                    checked: item.switch,
                    flag: flagIndex==index? true: false,
                    row: item.dataItem.map(_item => { return _item.text })
                }
            })
            this.tableData.push(...rowArr)
          
        },
        
	},
}
</script>
<style lang="scss" scoped>
.agenda-table {
	.tr {
		width: 100%;
		.th {
			border-top: 0.1rem solid #928f8e;
			border-bottom: 0.1rem solid #928f8e;
			padding: 1rem 0;

			.cell {
				border-left: 0.1rem solid #a6a3a2;
				padding: 0 2rem;
				text-align: left;
				color: #666666;
			}
		}
		.td {
			border-bottom: 0.1rem solid #928f8e;
			padding: 1rem 0;
			.cell {
				border-left: 0.1rem solid #a6a3a2;
				padding: 0 2rem;
				text-align: left;
				color: #666666;
			}
		}
		.lb {
			width: 0.64rem;
			background: #cfaf75;
			border-top: 0.1rem solid #cfaf75;
			border-bottom: 0.1rem solid #cfaf75;
		}
		.nlb {
			background: none;
			border-right: 0.1rem solid #928f8e;
			border-top: none;
			border-bottom: none;
			border-left: none;
		}
		.rb {
			width: 3.28rem;
			border-left: 0.1rem solid #928f8e;
			border-top: none;
			border-bottom: none;
			.regbtn {
				min-height: 1.64rem;
				width: 100%;
				background: #cfaf75;
				padding: 0.57rem 0;
				border-top-right-radius: 0.71rem;
				border-bottom-right-radius: 0.71rem;
				cursor: pointer;
				span {
					margin: 0 auto;
					display: block;
					width: 1rem;
					line-height: 1rem;
					color: #ffffff;
					font-size: 1rem;
				}
			}
		}
		.nrb {
			background: none;
			border-left: 0.1rem solid #928f8e;
			border-top: none;
			border-bottom: none;
		}
		.left {
			width: 20%;
			height: inherit;
			text-align: center;
			min-width: 10rem;
			vertical-align: middle;
		}
	}
}
</style>
